const defaultState = {};

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'REDIRECT':
      return {
        ...action,
      };
    default:
      return state;
  }
}
